import React from 'react'
import { Box, Typography } from '@mui/material'
import { PageContainer } from '../component/styled/PageContainer'
import { Helmet } from 'react-helmet-async'
import { Navbar } from '../component/shared/Navbar'
import { UserProfile } from '../component/profile/UserProfile'
import { useAuth } from '../api/context/UserAuthContext'
import { EditProfile } from '../component/profile/EditProfile'

export const ProfileScreen = () => {
  const { user } = useAuth()

  return (
    <PageContainer>
      <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
        <title>User Profile</title>
      </Helmet>
      <Navbar />
      <Box my={5}>
        <Typography variant='h1'>Profile</Typography>
        <UserProfile data={user} />
      </Box>

      <EditProfile />
    </PageContainer>
  )
}
